import { useTranslation } from 'react-i18next'
import { Wrapper, Row, Column } from './_styles'
import { InfoList, Info, Header } from '../FirstColumn/_styles'

const SecondColumn = ({ product }) => {
  const { t } = useTranslation()

  const wine = product?.wine
  const viticulture = wine?.techSheet?.viticulture ?? ''
  const vinification = wine?.techSheet?.vinification ?? ''
  const wineAging = wine?.techSheet?.wineAging ?? ''
  const vintageDetails = wine?.techSheet?.vintageDetails ?? ''
  const tastingNote = wine?.techSheet?.tastingNote ?? ''
  const servingTemperatureMax = wine?.servingTemperatureMax ?? ''
  const servingTemperatureMin = wine?.servingTemperatureMin ?? ''
  const foodPairsText = (wine?.foodPairs ?? [])
    .map(item => item?.localizedName)
    .filter(Boolean)
    .join(', ')

  return (
    <Wrapper>
      {viticulture && (
        <>
          <Header>{t('wine.techlist.viticulture')}</Header>
          <InfoList>
            <Info>
              {(viticulture || '').split('\n').map((paragraph, index) => (
                <div key={index}>{paragraph}</div>
              ))}
            </Info>
          </InfoList>
        </>
      )}
      {vinification && (
        <>
          <Header>{t('wine.techlist.vinification')}</Header>
          <InfoList>
            <Info>
              {(vinification || '').split('\n').map((paragraph, index) => (
                <div key={index}>{paragraph}</div>
              ))}
            </Info>
          </InfoList>
        </>
      )}
      {wineAging && (
        <>
          <Header>{t('wine.techlist.wineAging')}</Header>
          <InfoList>
            <Info>
              {(wineAging || '').split('\n').map((paragraph, index) => (
                <div key={index}>{paragraph}</div>
              ))}
            </Info>
          </InfoList>
        </>
      )}
      {vintageDetails && (
        <>
          <Header>{t('wine.techlist.vintage')}</Header>
          <InfoList>
            <Info>
              {(vintageDetails || '').split('\n').map((paragraph, index) => (
                <div key={index}>{paragraph}</div>
              ))}
            </Info>
          </InfoList>
        </>
      )}
      {tastingNote && (
        <>
          <Header>{t('wine.techlist.tastingNotes')}</Header>
          <InfoList>
            <Info>
              {(tastingNote || '').split('\n').map((paragraph, index) => (
                <div key={index}>{paragraph}</div>
              ))}
            </Info>
          </InfoList>
        </>
      )}
      {(foodPairsText || (servingTemperatureMax && servingTemperatureMin)) && (
        <Row>
          {foodPairsText && (
            <Column>
              <Header>{t('wine.techlist.foodPairings')}</Header>
              <InfoList>
                <Info>
                  {foodPairsText.split('\n').map((paragraph, index) => (
                    <div key={index}>{paragraph}</div>
                  ))}
                </Info>
              </InfoList>
            </Column>
          )}
          {servingTemperatureMax && servingTemperatureMin && (
            <Column>
              <Header>{t('wine.techlist.servingTemperature')}</Header>
              <InfoList>
                <Info>
                  {servingTemperatureMin === servingTemperatureMax ? (
                    <div>{servingTemperatureMin}&#176;C</div>
                  ) : (
                    <div>
                      {servingTemperatureMin}&#176;C &#8211;{' '}
                      {servingTemperatureMax}&#176;C
                    </div>
                  )}
                </Info>
              </InfoList>
            </Column>
          )}
        </Row>
      )}
    </Wrapper>
  )
}

export default SecondColumn
